import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import ErrorBoundary from "@/components/ErrorBoundary";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Account from "@/pages/Account";
import Dashboard from "@/pages/Dashboard";
import Catalog from "@/pages/Catalog";
import Clientes from "@/pages/Clientes";
import QuotationList from "@/pages/QuotationList";
import QuotationForm from "@/pages/QuotationForm";
import QuotationDetail from "@/pages/QuotationDetail";
import CRM from "@/pages/CRM";
import Materiales from "@/pages/Materiales";
import Insumos from "@/pages/Insumos";
import Gastos from "@/pages/Gastos";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Cargando…</div>;
  }
  if (!user) {
    return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/*"
                element={
                  <Protected>
                    <Layout>
                      <ErrorBoundary>
                        <Routes>
                          <Route path="/" element={<Dashboard />} />
                          <Route path="/cotizaciones" element={<QuotationList />} />
                          <Route path="/cotizaciones/nueva" element={<QuotationForm />} />
                          <Route path="/cotizaciones/:id" element={<QuotationDetail />} />
                          <Route path="/cotizaciones/:id/editar" element={<QuotationForm />} />
                          <Route path="/catalogo" element={<Catalog />} />
                          <Route path="/materiales" element={<Materiales />} />
                          <Route path="/insumos" element={<Insumos />} />
                          <Route path="/gastos" element={<Gastos />} />
                          <Route path="/clientes" element={<Clientes />} />
                          <Route path="/crm" element={<CRM />} />
                          <Route path="/cuenta" element={<Account />} />
                        </Routes>
                      </ErrorBoundary>
                    </Layout>
                  </Protected>
                }
              />
            </Routes>
            <Toaster position="top-right" richColors />
          </AuthProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
